.navigation {
  display: flex;
  justify-content: flex-end;
  margin-top: 5em;

  &>a {
    margin-left: 1em;
  }

  &>button {
    margin-left: 1em;
  }
}

.header {
  text-transform: unset;
}

.infoBox {
  width: 100%;
  padding: 2em 0;
}

.label {
  flex-basis: 15%;
  padding-right: 2em;
}

.info {
  flex-basis: 85%;
}

.row {
  display: flex;
  min-height: 2em;
}

.saveSuccess {
  display: none;
  color: var(--greenSuccess);

  &.visible {
    display: flex;
    justify-content: flex-end;
  }

  p {
    margin-bottom: 0;
  }
}

.roleLabel {
  font-size: 1em !important;
}

.roleGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75em 1.5em;
}

.matrixTable {
  font-size: 0.9em;
}

.matrixHeaderSurveyType {
  border-bottom: 2px solid var(--darkSilver);
  padding: 0.5em;
  min-width: 9em;
}

.matrixHeaderCell {
  text-align: center;
  border-bottom: 2px solid var(--darkSilver);
  padding: 0.5em;
}

.matrixSurveyTypeCell {
  font-weight: 600;
  padding: 0.5em;
  border-bottom: 1px solid var(--mediumSilver);
}

.matrixCell {
  padding: 0.5em;
  border-bottom: 1px solid var(--mediumSilver);
  text-align: center;
}

.matrixCheckboxWrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.8em;
}

.matrixTable tr:nth-child(even) {
  background-color: var(--silver);
}

